module.exports = __webpack_public_path__ + "static/media/capture-insights.5f90791d.png";